module.exports = __webpack_public_path__ + "static/media/chuncks.9a57931d.png";